//import { Profile, User, UserSubmit, UserForUpdate } from '../models';
//import { advenueService } from '@/_services/advenue.service'
/* global localStorage */
import axios from 'axios';
import router from '@/router'
import qs from "qs";
import * as localforage from "localforage";

//import ServiceWorkerStorage from 'serviceworker-storage';
//const storage = new ServiceWorkerStorage('sw:storage', 1);


const API_URL = process.env.API_URL || 'https://mobile.innity.com.my/apipost/index.php'
//'https://1techpark.innity.com.my/apipost/index.php'
//
//

 export const loginService = {
     login,
     logout,
     getDashBoard,
     flightRequest,
     camdetail,
     flightbyPending,
     flightbyCam,
     getAIOAcess,
     updatestatus,
     getFlightReport,
     getReportFull,
     camlist,
     camSearch,
     updateverifyaio,
     updaterejectaio,
     getSaleId,

 };


function login(User){
  return axios(API_URL+'/login', {
          method: 'POST',
          data: {
            action:"login",
            username: User.username,
            password: User.password
            },
          headers:{
            'Content-type': 'application/json'
          },
        })
      .then(response => {
          const data = response.data;

          if ((typeof data === 'object') && data !==null   ) {
            const user = JSON.stringify(data)

            const token = btoa(JSON.parse(user).id +","+JSON.parse(user).firstname +','+ JSON.parse(user).lastname +","+JSON.parse(user).email)
            //localStorage.setItem('user', user) && Object.keys(data).length > 0
            localStorage.setItem('token', token)
            localforage.setItem('userId',JSON.parse(user).id )
            // console.log(user);
            return user
          }else{
            return []
          }

      })
      .catch((error) => {
         return []
      });
}
// function getsalePrivilege(saleid){

//   const params={
//       action:'salePrivilege',
//       saleid:saleid
//     }
//     const url = `${API_URL}` ;
//     return axios.get(url, {
//         params
//     }).then(response =>response.data).catch(err => {
//       console.log(err);
//     });

// }
function getSaleId(){

    if (localStorage.getItem("token")){
     var strUser = atob(localStorage.token);
     var arrayUser = strUser.split(",");
      return arrayUser[0];
   }
}


async function getDashBoard(type=""){
    const saleid = getSaleId()
    const params={
      action:'dashboard',
      type:`${type}`,
      saleid:saleid
    }
    const url = `${API_URL}` ;
    //console.log(url+ "?action=dashboard"+"&type="+type+"$saleid="+saleid )
    // var myInit = { method: 'GET',
    //            headers: {
    //               'content-type': 'application/json',
    //            },
    //            mode: 'cors',
    //            cache: 'default' };

    // const req = new Request(url+ "?action=dashboard"+"&type="+type+"&saleid="+saleid , {
    //                 myInit
    //             });

    //  return await fetch(req)
    //         .then(res => res.json()).catch(err => {
    //           console.log(err);
    //         });
         // convert to plain text
           // .then(text => console.log(text)) //log the data; // Transform the data into json
      // .then(function(data) {
      //  // console.log(data)
      //       return dataif (!response.ok) { throw Error(response.statusText) }
 // return response
      //   // Create and append the li's to the ul
      //  })


      // fetch(req).then(function(response) {
      //   if (response.status !== 200) {
      //    console.log('Looks like there was a problem. Status Code: ' +
      //     response.status);
      //     return;
      //   }

      //   // Examine the text in the response
      //   return await response.json();
      // });

    return axios.get(url, {
        params
    }).then(response =>response.data).catch(err => {
      console.error(err);
    });

}
function logout() {
    // remove user from local storage to log user out
    //console.log("logout function")
    localStorage.removeItem('token')
    //localStorage.removeItem('user')
}
function flightRequest(detail){
    const saleid = getSaleId()

    return axios(API_URL+'/flightRequest', {
          method: 'POST',
          data: {
            action:"flightRequest",
            saleid:saleid,
            detail: JSON.stringify(detail)
            },
          headers:{
            'Content-type': 'application/json'
          },
        })
      .then(response => {
          // const data = response.data;
          // if ((typeof data === 'object') && Object.keys(data).length > 0 ) {
          //   const user = JSON.stringify(data)

          //   const token = btoa(JSON.parse(user).id +","+JSON.parse(user).firstname +','+ JSON.parse(user).lastname)
          //   //localStorage.setItem('user', user)
          //   localStorage.setItem('token', token)
          //    //console.log(localStorage.getItem('user'));
          //   return user
          // }else{
          //   return "null"
          // }

      })
      .catch((error) => {
          console.error(error);
      });
}

function updatestatus(detail){
    const saleid = getSaleId()

    return axios(API_URL+'/updatestatus', {
          method: 'POST',
          data: {
            action:"updatestatus",
            saleid:saleid,
            detail: JSON.stringify(detail)
            },
          headers:{
            'Content-type': 'application/json'
          },
        })
      .then(response => {
          return response.data;

      })
      .catch((error) => {
          console.error(error)
      });
}
function updateverifyaio(detail){
    const saleid = getSaleId()

    return axios(API_URL+'/updateverifyaio', {
          method: 'POST',
          data: {
            action:"updateverifyaio",
            detail: JSON.stringify(detail),
            saleid:saleid
            },
          headers:{
            'Content-type': 'application/json'
          },
        })
      .then(response => {
          return response.data
          // const data = response.data;
          // if ((typeof data === 'object') && Object.keys(data).length > 0 ) {
          //   const user = JSON.stringify(data)

          //   const token = btoa(JSON.parse(user).id +","+JSON.parse(user).firstname +','+ JSON.parse(user).lastname)
          //   //localStorage.setItem('user', user)
          //   localStorage.setItem('token', token)
          //    //console.log(localStorage.getItem('user'));
          //   return user
          // }else{
          //   return "null"
          // }

      })
      .catch((error) => {
          console.log(error)
      });
}
function updaterejectaio(detail){
    const saleid = getSaleId()

    return axios(API_URL+'/updaterejectaio', {
          method: 'POST',
          data: {
            action:"updaterejectaio",
            detail: JSON.stringify(detail),
            saleid:saleid
            },
          headers:{
            'Content-type': 'application/json'
          },
        })
      .then(response => {
          // const data = response.data;
          // if ((typeof data === 'object') && Object.keys(data).length > 0 ) {
          //   const user = JSON.stringify(data)

          //   const token = btoa(JSON.parse(user).id +","+JSON.parse(user).firstname +','+ JSON.parse(user).lastname)
          //   //localStorage.setItem('user', user)
          //   localStorage.setItem('token', token)
          //    //console.log(localStorage.getItem('user'));
          //   return user
          // }else{
          //   return "null"
          // }

      })
      .catch((error) => {
          console.error(error)
      });
}
async function camdetail(id){

   const saleid = getSaleId()
   const params={
      action:'camdetail',
      id:id,
      saleid:saleid
    }
    const url = `${API_URL}`  ;
    //console.log(url+ "?action=dashboard"+"&type="+type+"$saleid="+saleid )
    var myInit = { method: 'GET',
               headers: {
                  'content-type': 'application/json',
               },
               mode: 'cors',
               cache: 'default' };

    const req = new Request(url+ "?action=camdetail"+"&id="+id+"&saleid="+saleid , {
                    myInit
                });

   // console.log(req);
     return await fetch(req)
      .then((resp) => resp.json()).catch(error => console.error(error)); // Transform the data into json

    // const url = `${API_URL}`;
    // //console.log(url)
    // return axios.get(url, {
    //     params
    // }).then(response =>response.data)
}
async function flightbyCam(cid){
    const saleid = getSaleId()
    const params={
      action:'flightByCam',
      cid:cid,
      saleid:getSaleId()
    }
    const url = `${API_URL}`;
    var myInit = { method: 'GET',
               headers: {
                  'content-type': 'application/json',
               },
               mode: 'cors',
               cache: 'default' };

    const req = new Request(url+ "?action=flightByCam"+"&cid="+cid +"&saleid="+ saleid, {
                    myInit
                });

   // console.log(req);
     return await fetch(req)
      .then((resp) => resp.json()).catch(error => console.error(error)); // Transform the data into json
  // console.log(params)
    // return axios.get(url, {
    //     params
    // }).then(response =>response.data)
}
async function flightbyPending(cid){
    const saleid = getSaleId()
    const params={
      action:'flightbyPending',
      cid:cid,
      saleid:getSaleId()
    }
    const url = `${API_URL}`;
    var myInit = { method: 'GET',
               headers: {
                  'content-type': 'application/json',
               },
               mode: 'cors',
               cache: 'default' };

    const req = new Request(url+ "?action=flightbyPending"+"&cid="+cid +"&saleid="+saleid, {
                    myInit
                });

   // console.log(req);
     return await fetch(req)
      .then((resp) => resp.json()).catch(error => console.error(error)); // Transform the data into json
  // console.log(params)
    // return axios.get(url, {
    //     params
    // }).then(response =>response.data)
}

function getAIOAcess(){
   const saleid = getSaleId()
   const params={
      action:'AIOAcess',
      saleid:saleid
    }

    const url = `${API_URL}`;
 //  console.log(params)
    return axios.get(url, {
        params
    }).then(response =>response.data)

}
function getFlightReport(search=[]){
    const saleid = getSaleId()
    const params={
      action:'flightDetail',
      id:search.id,
      saleid:saleid,
      sdate:search.stDate,
      edate:search.edDate,
      page:search.page
    }
    const url = `${API_URL}`;

    return axios.get(url, {
      params
    }).then(response =>response.data)




}
//report full
// function getReportFull(sdate='',edate='',id){
async function getReportFull(search=[]){
   const saleid = getSaleId()
    const params={
      action:'reportFull',
      id:search.id,
      saleid:saleid,
      sdate:search.stDate,
      edate:search.edDate,
      page:search.page
    }
    const url = `${API_URL}`;
    var myInit = { method: 'GET',
               headers: {
                  'content-type': 'application/json',
               },
               mode: 'cors',
               cache: 'default' };

    const req = new Request(url+ "?action=reportFull"+"&id="+search.id+"&saleid="+ saleid +"&sdate="+search.stDate+"&edate="+ search.edDate +"&page="+search.page , {
                    myInit
                });

   // console.log(req);
     return await fetch(req)
      .then((resp) => resp.json()).catch(error => console.error(error)); // Transform the data into json

  //   console.log(params)
    // return axios.get(url, {
    //     params
    // }).then(response =>response.data)
}
//cam list
async function camSearch(search=[]){


   const saleid = getSaleId()
   const page = search.page
   const data = {name:search.name? search.name : null,
                 daterange:search.daterange ? search.daterange: null,
                advertiser:search.advertiser ? search.advertiser: null,
                agency:search.agency ? search.agency: null,
                salesperson:search.salesperson ? search.salesperson:  null ,
                status:search.status? search.status: null,
                country:search.country ? search.country: null,
                }
  const params={
      action:'campaign',
      saleid:saleid,
      page:page,
      search:data

    }
    const url = `${API_URL}`;
    const req = new Request(url+ "?action=campaign"+"&page="+page+"&saleid="+saleid+"&search="+ JSON.stringify(data) , {
                    myInit
                });

   var myInit = { method: 'GET',
                 headers: {
                    'content-type': 'application/json',
                 },
                 mode: 'cors',
                 cache: 'default' };
    return await fetch(req).then((resp) => resp.json()).catch(err => {
      console.error('Request failed', err)
    })



  // return axios.post(url,params).then(response => {
  //  // console.log(response)
  //         return response.data;
  //     }).catch(error => {
  //       if (error.response.status === 422) {
  //          return error.response.status  || {};
  //       }
  //     });

}
async function camlist(search=[]){
   const saleid = getSaleId()
   const page = search.page
   const data = {name:search.name? search.name : null,
                 daterange:search.daterange ? search.daterange: null,
                advertiser:search.advertiser ? search.advertiser: null,
                agency:search.agency ? search.agency: null,
                salesperson:search.salesperson ? search.salesperson:  null ,
                status:search.status? search.status: null,
                country:search.country ? search.country: null,
                }
   const params={
      action:'campaign',
      saleid:saleid,
      page:page,
      search:data

    }

   //  const url = `${API_URL}`  ;
    //console.log(url+ "?action=dashboard"+"&type="+type+"$saleid="+saleid )
   //  var myInit = { method: 'GET',
   //             headers: {
   //                'content-type': 'application/json',
   //             },
   //             mode: 'cors',
   //             cache: 'default' };

   //  const req = new Request(url+ "?action=campaign"+"&page="+page+"&saleid="+saleid+"&search="+ JSON.stringify(data) , {
   //                  myInit
   //              });

   // // console.log(req);
   //   return await fetch(req)
   //    .then((resp) => resp.json()).catch(error => console.error(error)); // Transform the data into json

    const url = `${API_URL}`;
  // //console.log(params)
    return axios.get(url, {
        params
    }).then(response =>response.data)
}
